import React from 'react';
import { PrimaryButton } from '../../../components/common';
import { useAnalytics } from '../../../hooks/use-analytics';
import { isIMGTakataRoute } from './recalls-util';

interface Props {
    recallsContent: any;
    isYmm: boolean;
    preferredDealer: any;
    vinToSearch: string;
}

export const RecallsVinDealerButton = (props: Props) => {
    const [fireEvents] = useAnalytics();
    const isImgTakataRoute = isIMGTakataRoute();
    const recallsResultsCtaClickEvent = isImgTakataRoute
        ? 'takata-recalls-results-cta'
        : 'recalls-results-cta';
    const ctaHref = () => {
        if (props.preferredDealer)
            return props.preferredDealer.scheduleServiceUrl;
        else if (
            props.recallsContent &&
            props.recallsContent.findADealerButtonLink &&
            props.recallsContent.findADealerButtonLink.includes('%vin') &&
            props.vinToSearch
        ) {
            return props.recallsContent?.findADealerButtonLink?.replace(
                '%vin',
                props.vinToSearch
            );
        } else return props.recallsContent?.findADealerButtonLink || '';
    };

    return (
        <>
            {props.recallsContent.findADealerButtonText && !props.isYmm ? (
                <div
                    className="recalls-details__dealer-button-container"
                    data-testid="find-a-dealer-button"
                >
                    <PrimaryButton
                        color="dark"
                        fill="fill"
                        chevron={true}
                        className="recalls-details__dealer-button"
                        target="_blank"
                        href={ctaHref()}
                        onClick={() => {
                            fireEvents(
                                recallsResultsCtaClickEvent,
                                undefined,
                                {
                                    ctaType: 'find a dealer',
                                },
                                false
                            );
                        }}
                    >
                        <span>
                            {props.preferredDealer
                                ? props.recallsContent
                                      .preferredDealerButtonLabel
                                : props.recallsContent.findADealerButtonText}
                        </span>
                    </PrimaryButton>
                </div>
            ) : (
                <div className="ymm-recalls-message">
                    {props.recallsContent.ymmRecallsMessage}
                </div>
            )}
        </>
    );
};
